
import { Box, Paper, Tab, Tabs, Tooltip, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TuneIcon from '@mui/icons-material/Tune';

import TabList 				from "./components/TabList";
import TabParameters 		from "./components/TabParameters";
import useFetch 			from "../../api/api";
import useInternalFetch		from "../../api/apiInternal";
import Loading 				from "../../components/Loading";
import PortfolioContext 	from "./context";
import config 				from "../../common/Config";
import { filterPublicFields }	from "../../common/Fields";
import TabGeneral 			from "./components/TabGeneral";

const Portfolio = () => {

	const {assetType}								= useParams()

	const privateFetch								= useFetch()
	const internalFetch								= useInternalFetch()

	const [currentTabIndex, setCurrentTabIndex] 	= useState(0)
	const [isLoading, setIsLoading]					= useState(true)
	const [userViews, setUserViews]					= useState()
	const [allFields, setAllFields]					= useState()
	const [convertToDollar, setConvertToDollar]				= useState(false)
	const [analyzeQuarterly, setAnalyzeQuarterly]			= useState(false)
	const [allowFailedRiskGrowth, setAllowFailedRiskGrowth]	= useState(false)
	const [investmentIntervalDays, setInvestmentIntervalDays] = useState(0)
	const [investByDate, setInvestByDate]					= useState(false)
	const [toolbarOpen, setToolbarOpen]						= useState(false)

	const showFilterButton = (currentTabIndex === 1 || currentTabIndex === 2) && (allFields?.length > 0 || userViews?.length > 0)

	useEffect(() => {
		setIsLoading(true)

		switch (assetType) {
			case "ACAO": 	setCurrentTabIndex(1); break;
			case "STOCK":	setCurrentTabIndex(2); break;
			default:		setCurrentTabIndex(0);
		}

		Promise.all([
			privateFetch(config.apiUrl +'/api/portfolio/settings').then(r => r.json()),
			internalFetch(config.apiUrl +'/api/screener/fields')
		]).then(([settings, fields]) => {
			const payload = settings.data;
			setUserViews(Array.isArray(payload?.views) ? payload.views : [])
			setConvertToDollar(payload?.settings?.convertToDollar ?? false)
			setAnalyzeQuarterly(payload?.settings?.analyzeQuarterly ?? false)
			setAllowFailedRiskGrowth(payload?.settings?.allowFailedRiskGrowth ?? false)
			setInvestmentIntervalDays(payload?.settings?.investmentIntervalDays ?? 0)
			setInvestByDate(payload?.settings?.investByDate ?? false)
			setAllFields(Array.isArray(fields) ? filterPublicFields(fields) : [])
			setIsLoading(false)
		})
	}, [assetType])

	return (
		<PortfolioContext.Provider value={{
			userViews,
			setUserViews,
			allFields,
			setAllFields,
			convertToDollar,
			setConvertToDollar,
			analyzeQuarterly,
			setAnalyzeQuarterly,
			allowFailedRiskGrowth,
			setAllowFailedRiskGrowth,
			investmentIntervalDays,
			setInvestmentIntervalDays,
			investByDate,
			setInvestByDate,
			}}>
			<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, minHeight:'88vh'}} elevation={1}>
				<Box margin={1} width={'99%'} height={'100%'} sx={{ overflowX: 'hidden' }}>
					<Box display="flex" alignItems="center" sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={currentTabIndex}
							onChange={(_, tabIndex) => setCurrentTabIndex(tabIndex)}
							sx={{ flex: 1 }}
						>
							<Tab label='Geral'/>
							<Tab label='Ações'/>
							<Tab label='Stocks'/>
							<Tab label={"Parâmetros"}/>
						</Tabs>
						{showFilterButton && (
							<Tooltip title="Opções de visualização">
								<IconButton
									size="small"
									onClick={() => setToolbarOpen(o => !o)}
									color={toolbarOpen ? 'primary' : 'default'}
									sx={{ mr: 1 }}
								>
									<TuneIcon sx={{ fontSize: 18 }}/>
								</IconButton>
							</Tooltip>
						)}
					</Box>
					{ isLoading || !userViews ? (
						<Loading />
					) : (
						<Box sx={{ position: 'relative', width: '100%', height: '80vh', pb: 2 }}>
							<Box
								role="tabpanel"
								aria-hidden={currentTabIndex !== 0}
								sx={{ display: currentTabIndex === 0 ? 'block' : 'none', height: '100%' }}
								>
								<TabGeneral/>
							</Box>
							{ currentTabIndex === 1 && (
								<Box
									role="tabpanel"
									aria-hidden={currentTabIndex !== 1} // Para evitar reload
									height={'100%'}
									>
									<TabList assetType='ACAO' toolbarOpen={toolbarOpen}/>
								</Box>
							)}
							{ currentTabIndex === 2 && (
								<Box
									role="tabpanel"
									aria-hidden={currentTabIndex !== 1} // Para evitar reload
									height={'100%'}
									>
									<TabList assetType='STOCK' toolbarOpen={toolbarOpen}/>
								</Box>
							)}
							<Box
								role="tabpanel"
								aria-hidden={currentTabIndex !== 3}
								sx={{ display: currentTabIndex === 3 ? 'block' : 'none', height: '100%' }}
								>
								<TabParameters />	
							</Box>
						</Box>
					)}
				</Box>
			</Paper>
		</PortfolioContext.Provider>
	)

}


export default Portfolio
